<div class="modal-content p-0 m-0">
  <div (click)="close()" class="row d-flex justify-content-end closebtn mx-4">x</div>
  <div class="row m-0 p-0">
      <div class="col-sm-12 col-md-12 col-lg-6 p-4 p-0 m-0">
        <form class="box-form d-flex align-items-center h-100 p-4">
          <fieldset>
            <legend class="legend-title">Seja Bem Vindo(a) !</legend>
            <div class="form-row mt-3">
              <div class="form-group col-sm-12">
                <label for="" class="form-label">Email</label>
                <input name="email" formControlName="email" type="text"  class="form-control" placeholder="Digite seu email">
              </div>
              <div class="form-group col-sm-12">
                <label for="" class="form-label">Senha</label>
                <input name="senha" formControlName="senha" type="password" class="form-control" placeholder="Digite sua senha">
              </div>
              <div class="form-group col-sm-12">
                <a (click)='resetSenha()' class="btn-lost-password"> <u> Esqueci minha senha </u></a>
              </div>
            </div>
            <div class="form-row">
              <button (click)='login()' class="btn">Login</button>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="col-md-12 col-lg-6 col-sm-12 p-md-4 p-sm-0 m-sm-0">
        <form class="box-form p4">
          <fieldset class="p-md-4 p-0">
            <legend class="legend-title p-3">Primeiro Acesso ?</legend>
            <div class="border p-3 ">
            <p>
              Antes de realizar o seu cadastro neste canal, atente-se a algumas orientações. Este canal é exclusivo para Investidores:
            </p>
              <ul class="custom-list">
                <li class="text-bold">
                  - Pessoa Jurídica - Garantia Ordinária ou Garantia Especial (DPGE)
                </li>
                <li class="text-bold">
                  - Pessoa Física - Garantia Especial - DPGE
                </li>
                <br>
              </ul>
              <p>
                Se você é um investidor Pessoa Física - Garantia Ordinária (até
                250 mil), você deve se cadastrar,  solicitar e acompanhar o status da(s) sua(s) solicitação(es) de garantia diretamente no aplicativo FGC.
                <br> O aplicativo está disponível para download nas lojas:
              </p>
              <div class="d-flex justify-content-around align-center my-4">
                <button  class="btn-social px-4 py-2"><a href="https://apps.apple.com/br/app/fgc/id1534020542" target="_blank">  <i class="fab fa-apple"></i> Apple Store </a></button>
                <button class="btn-social px-4 py-2 "><a href="https://play.google.com/store/apps/details?id=br.com.app.fgc&hl=pt_BR&gl=US" target="_blank"> <i class="fab fa-google-play"></i> Google Play </a></button>
              </div>
            </div>
            <!-- <legend>Realizar Cadastro</legend> -->
            <div class="d-flex justify-content-center align-center mt-3">
              <button (click)='cadastro()' class="btn">Cadastrar-se</button>

            </div>
          </fieldset>
        </form>
      </div>
    </div>
</div>
